import types from './types';

const InitialState = {
    loaded: false,
    tournament: null,
    tournament_timestamp: null
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.unload:
            return {
                ...state,
                loaded: false,
                tournament: null
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                tournament: {
                    ...payload,
                    tournament_timestamp: payload.tournament_timestamp + Date.now()
                },
                tournament_timestamp: payload.tournament_timestamp + Date.now()
            }
        default:
            return state;
    }
}